<template>
  <TheNavbar />

  <div v-if="strategy" class="mt-5 mb-5">

    <div class="row justify-content-center mb-4">

      <div class="col-12 text-center">
        <h3>{{ strategy.tradingViewName }}</h3>
      </div>

      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6 mt-3">

        <div class="card">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">Get access now</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary">
            <p>
              Enter your TradingView username (e.g. tothemoon123) below to get access to this strategy. It needs your username not your email!
            </p>

            <StrategyGetAccessForm :strategyId="strategy.name" />

          </div> <!-- card-body-->
        </div>

      </div>
    </div>

    <div class="row justify-content-center mb-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

        <div class="card">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">How to find your TradingView username</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary">
            <p>
              Click on your profile icon on the top left...<br>
              <img class="img-fluid rounded mx-auto mb-3" src="@/assets/strategies/tv_username.jpg" />
            </p>
          </div> <!-- card-body-->
        </div>

      </div>
    </div>

    <div class="row justify-content-center mb-3">
      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">

        <div class="card">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">What to do next?</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary">
            <p>
              <span class="fw-bold">Once you have access (confetti was flying), follow these steps:</span>
            </p>

            <ol>
              <li>Open Strategy in <a :href="strategy.tradingViewUrl" target="_blank">TradingView <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-0"></span></a></li>
              <li>Click on "Add to favorites"</li>
              <li>Reload TradingView (F5 or CMD+R)</li>
              <li>Go back to your TradingView chart</li>
              <li>Click on Indicators in the top menu</li>
              <li>You'll now find it in your Favorites</li>
              <li>Click on it one-time to add it to your chart</li>
              <li>Done :)</li>
            </ol>

            <div v-if="videoUrl">
              <p>
                <span class="fw-bold">Watch this tutorial video to learn how this strategy works and how to automate it:</span>
              </p>
              <iframe width="100%" height="400" style="max-width: 800px;" :src="videoUrl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>

          </div> <!-- card-body-->
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import TheNavbar from '@/components/TheNavbar'
import StrategyGetAccessForm from '@/components/StrategyGetAccessForm'
import { userHelperMixin } from '@/mixins/userHelperMixin'

// Video URLs for strategies that have tutorial videos
const strategyVideos = {
  'GAUSSIAN_CHANNEL': 'https://www.youtube-nocookie.com/embed/aXP-gsw7kxE?si=a3XAEX5njS-SH0SP',
  'ICHIMOKU_EMA_4H': 'https://www.youtube.com/embed/dfsWBx6macw?si=AXcyoaXNryqlFuqA'
}

export default {
  mixins: [userHelperMixin],
  components: {
    TheNavbar,
    StrategyGetAccessForm
  },
  props: {
    strategyName: {
      type: String,
      required: true
    }
  },
  computed: {
    strategy () {
      return this.$store.getters.getStrategyByName(this.strategyName)
    },
    videoUrl () {
      if (!this.strategy) return null
      return strategyVideos[this.strategy.name] || null
    }
  },
  methods: {
    checkAccess () {
      // Redirect if that strategy does not exist or was not found
      if (!this.strategy || !this.strategy?.name ) {
        this.$router.push({ name: 'Strategies' })
        return null
      }

      // ATX strategies require both hasStrategyAccess AND isAutotradingUser
      if (this.strategy.isExclusiveForAutoTrading) {
        if (!this.userHasAccessToAtxStrategiesMix) {
          this.$router.push({ name: 'Strategies' })
        }
      } else {
        // SIGNUM strategies require hasStrategyAccess
        if (!this.userHasAccessToStrategiesMix) {
          this.$router.push({ name: 'Strategies' })
        }
      }
    }
  },
  async created () {
    if (!this.$store.getters.getUserBots) await this.$store.dispatch('getUserBots')
    if (!this.$store.getters.getStrategies) await this.$store.dispatch('getStrategies')

    await this.checkAccess()
  },
  beforeMount () {
    // Redirect to Login when the user is not logged in
    if (!this.$store.getters.isUserLoggedIn) this.$router.push({ name: 'Login' })
  }
}
</script>
